__webpack_require__.p = "/sh-capstone-admin/";